import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { 
    GetUserResponse,
} from '../models/users.models'; 
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UsersService { 
  private apiUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService,  private authService: AuthService) {
    this.apiUrl = `${this.configService.getConfig().apiBaseUrl}/Login`;
  }

  private getHeaders(): HttpHeaders {
    const token = this.authService.getToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  
  getUserInfo(): Observable<GetUserResponse> {
    return this.http.get<GetUserResponse>(`${this.apiUrl}/GetUser`, { headers: this.getHeaders() });
  }
}
